import {Route} from '@angular/router';
import {PublicComponent} from '@public/public.component';
import {PublishActivityComponent} from '@public/activity/publish-activity/publish-activity.component';
import {ActivityComponent} from '@public/activity/activity.component';
import {SearchActivityComponent} from '@public/activity/search-activity/search-activity.component';
import {ActivityResolver} from '@domain/activity/activity.resolver';
import {FaqComponent} from '@public/page/faq/faq.component';
import {PartnersComponent} from '@public/page/partners/partners.component';
import {ContactComponent} from '@public/page/contact/contact.component';
import {AboutComponent} from '@public/page/about/about.component';
import {SupportUsComponent} from '@public/page/support-us/support-us.component';
import {HostResolver} from '@domain/host/host.resolver';
import {HostComponent} from '@public/host/host.component';
import {ActivityHomeComponent} from '@public/activity/activity-home/activity-home.component';
import {HostHomeComponent} from '@public/host/host-home/host-home.component';
import {TermsDashboardComponent} from '@public/page/terms/terms-dashboard/terms-dashboard.component';
import {TermsPublishComponent} from '@public/page/terms/terms-publish/terms-publish.component';
import {TermsPrivacyComponent} from '@public/page/terms/terms-privacy/terms-privacy.component';
import {PublicDashboardComponent} from '@public/public-dashboard/public-dashboard.component';
import {HostActivityResolver} from '@domain/activity/host-activity.resolver';
import {PlaceResolver} from '@domain/place/place.resolver';
import {PlaceComponent} from '@public/place/place.component';
import {PlaceHomeComponent} from '@public/place/place-home/place-home.component';
import {publicSlugGuard} from '@public/public-slug.guard';

export const PUBLIC_ROUTES: Route[] = [
  {
    path: '',
    component: PublicComponent,
    children: [
      // "old style" routes -> keep them for a while for backward compatibility
      {path: 'publish-activity', component: PublishActivityComponent },
      {path: 'search', component: SearchActivityComponent },
      {
        path: 'a/:slug',
        redirectTo: (redirectData) => {
          const slug = redirectData.params?.['slug'];
          return `/activity/${slug}`;
        },
        resolve: {
          activity: ActivityResolver.get
        }
      },
      {
        path: 'h/:slug',
        redirectTo: (redirectData) => {
          const slug = redirectData.params?.['slug'];
          return `/host/${slug}`;
        },
        resolve: {
          host: HostResolver.get,
          activities: HostActivityResolver.publicActivities
        }
      },
      // "new style" routes:
      {
        path: 'activity',
        component: ActivityComponent,
        children: [
          {path: 'search', component: SearchActivityComponent },
          {path: 'publish', component: PublishActivityComponent },
          {
            path: ':slug',
            canActivate: [publicSlugGuard],
            component: ActivityHomeComponent,
            resolve: {
              activity: ActivityResolver.get
            }
          }
        ]
      },
      {
        path: 'host',
        component: HostComponent,
        children: [
          {
            path: ':slug',
            canActivate: [publicSlugGuard],
            component: HostHomeComponent,
            resolve: {
              host: HostResolver.get,
              activities: HostActivityResolver.publicActivities
            }
          }
        ]
      },
      {
        path: 'place',
        component: PlaceComponent,
        children: [
          {
            path: ':slug',
            canActivate: [publicSlugGuard],
            component: PlaceHomeComponent,
            resolve: {
              place: PlaceResolver.get,
              stats: PlaceResolver.getStats
              // activities: HostActivityResolver.publicActivities
            }
          }
        ]
      },
      {
        path: 'terms',
        children: [
          {path: 'publish', component: TermsPublishComponent},
          {path: 'privacy', component: TermsPrivacyComponent},
          {path: '', component: TermsDashboardComponent}
        ]
      },
      {path: 'faq', component: FaqComponent, data: {contentClasses: ['bg-light-purple']}},
      {path: 'partners', component: PartnersComponent, data: {contentClasses: ['bg-dark-blue']}},
      {path: 'contact', component: ContactComponent, data: {contentClasses: ['bg-light-purple']}},
      {path: 'about', component: AboutComponent},
      {path: 'support-us', component: SupportUsComponent},
      {
        path: '',
        component: PublicDashboardComponent,
        resolve: {
          region: PlaceResolver.getRegionByCode('NE'),
        }
      }
    ]
  }
];
